import { Service } from "./service"
import { PatchPayload } from "./types"

export const InventoryStockDocumentDefinitionService = Service

export type InventoryStockDocumentDefinitionPayloads = {
    Patch: PatchPayload
}


// WEBPACK FOOTER //
// ./src/state/inventory/stockDocumentDefinition/services/index.ts